<template>
  <div>
    <div style="display: flex;">
      <GlobalInfoBar>
        会员详情
      </GlobalInfoBar>
      <div
        style="background-color: #fff;display: flex;justify-content: center;align-items: center; height: 52px;margin-bottom: 20px;">
        <el-button type="success" @click=goBack()>返回</el-button>
      </div>
    </div>
    <div style="background-color: #fff;width: 100%;padding: 30px;">
      <div>
        <h1>会员信息</h1>
        <div style="padding: 15px;font-size: 15px;">
          <el-form label-position="right" label-width="110px">
            <el-form-item label="会员号：">
              {{ infoDetails.card_number }}
            </el-form-item>
            <el-form-item label="会员方案名称：">
              {{ infoDetails.plan_title }}
            </el-form-item>
            <el-form-item label="支付金额：">
              {{ infoDetails.amount }}
            </el-form-item>
            <el-form-item label="卡面储值额：">
              {{ infoDetails.parvalue }}
            </el-form-item>
            <el-form-item label="当前储值余额：">
              {{ infoDetails.balance }}
            </el-form-item>
            <el-form-item label="会员名称：">
              {{ infoDetails.name }}
            </el-form-item>
            <el-form-item label="手机号：">
              {{ infoDetails.phone }}
            </el-form-item>
            <el-form-item label="购机串号：">
              {{ infoDetails.imei }}
            </el-form-item>
            <el-form-item label="申请时间：">
              {{ infoDetails.add_time }}
            </el-form-item>
          </el-form>

          <!-- <div>会员号：{{ infoDetails.card_number }}</div>
          <div>会员方案名称：{{ infoDetails.plan_title }}</div>
          <div>支付金额：{{ infoDetails.amount }}</div>
          <div>卡面储值额：{{ infoDetails.parvalue }}</div>
          <div>当前储值余额：{{ infoDetails.balance }}</div>
          <div>会员名称：{{ infoDetails.name }}</div>
          <div>手机号：{{ infoDetails.phone }}</div>
          <div>购机串号：{{ infoDetails.imei }}</div>
          <div>申请时间：{{ infoDetails.add_time }}</div> -->
        </div>
      </div>
      <div>
        <h1>权益信息</h1>
        <div style="padding: 15px;">
          <el-table :data="infoDetails.plan_interests" style="width: 60%">
            <el-table-column type="index" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="interest_name" label="权益名称" align="center">
            </el-table-column>
            <el-table-column prop="interest_content" label="权益内容" align="center">
            </el-table-column>
          </el-table>
        </div>

      </div>
      <div>
        <h1>赠品信息</h1>
        <div style="padding: 15px;">
          <el-table :data="infoDetails.plan_goods" style="width: 60%">
            <el-table-column type="index" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="产品" align="center">
            </el-table-column>
            <el-table-column prop="goods_num" label="数量" align="center">
            </el-table-column>
            <el-table-column prop="goods_price" label="数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.goods_price }}元
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 15px 0;">
            合计：{{ goods_all_price }}元

          </div>

        </div>
      </div>
      <div>
        <h1>门店信息</h1>
        <div style="padding: 15px;font-size: 15px;">
          <el-form label-position="right" label-width="110px">
            <el-form-item label="门店商名称：">
              {{ infoDetails.store_name }}
            </el-form-item>
            <el-form-item label="门店名称：">
              {{ infoDetails.shop_name }}
            </el-form-item>
            <el-form-item label="店员名称：">
              {{ infoDetails.staff_name }}
            </el-form-item>
            <el-form-item label="店员手机号：">
              {{ infoDetails.staff_phone }}
            </el-form-item>
          </el-form>
          <!-- <div>门店商名称：{{ infoDetails.store_name }}</div>
          <div>门店名称：{{ infoDetails.shop_name }}</div>
          <div>店员名称：{{ infoDetails.staff_name }}</div>
          <div>店员手机号：{{ infoDetails.staff_phone }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  userCardInfo
} from "@/utils/request/membershipSystem";


export default {
  name: "memberDetails",
  data() {
    return {
      infoDetails: {},
      goods_all_price: 0,
    }
  },
  mounted() {
    const { card_id } = this.$route.query;
    console.log('card_id:', card_id);
    userCardInfo({
      card_id
    }).then(res => {
      this.infoDetails = res.data
      this.goods_all_price = this.infoDetails.plan_goods.reduce((sum, item) => sum + (item.goods_num * (Number(item.goods_price))), 0);

    })

  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped lang="scss"></style>